// recoil module atom
import { atom } from "recoil";

// create atom for auth
export const authAtom = atom({
  key: "auth",
  default: JSON.parse(localStorage.getItem("profile")),
});
